export const ELASTIC_TABLES = {
	AnalysisContent: 'analysis_content',
	LawCommentContent: 'law_comment_content',
	LawContent: 'law_content',
	LegalCaseContent: 'legal_case_content',
	PreparatoryWorkContent: 'preparatory_work_content',
	PropositionContent: 'proposition_content',
	RegulationContent: 'regulation_content',
};

export const PROPOSITION_TYPES = {
	PROP: 'PROP',
	PROP_EXCERPT: 'PROP_EXCERPT',
};

export const ALTERNATIVE_SOURCE_LIMITS = {
	LegalCaseContent: 2,
	LawCommentContent: 1,
	PreparatoryWorkContent: 0,
	PropositionContent: 2,
	AnalysisContent: 1,
	LawContent: 2,
	RegulationContent: 2,
};

export const RAG_ERROR_CODES = {
	0: { langKey: 'team_not_found', toastLevel: 'error' },
	1: { langKey: 'team_not_active', toastLevel: 'warn' },
	2: { langKey: 'user_not_found', toastLevel: 'error' },
	3: { langKey: 'user_not_active', toastLevel: 'warn' },
	4: { langKey: 'quota_exceeded', toastLevel: 'warn' },
	5: { langKey: 'quota_not_found', toastLevel: 'error' },
	6: { langKey: 'tier_not_found', toastLevel: 'error' },
	7: { langKey: 'conversation_meta_not_found', toastLevel: 'error' },
	8: { langKey: 'conversation_not_found', toastLevel: 'error' },
	9: { langKey: 'conversation_not_created', toastLevel: 'error' },
	10: { langKey: 'feedback_not_found', toastLevel: 'info' },
	11: { langKey: 'feedback_not_created', toastLevel: 'error' },
};

export const PROGRESS_DURATION = 30000; // 30 seconds
export const EXPIRATION_TIME = 1000 * 60 * 60 * 24 * 90; // 90 days

export const NUM_DAYS_HISTORY = 90;

export const DISPLAY_QUOTA_THRESHOLD = 10;
